import script from "./UpgradeRowItem.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradeRowItem.vue?vue&type=script&setup=true&lang=js"

import "./UpgradeRowItem.vue?vue&type=style&index=0&id=278b7a44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-278b7a44"]])

export default __exports__